module.exports = __webpack_public_path__ + "static/media/nightowls.5dcd18d0.jpg";